import { createReducer, on } from '@ngrx/store';
import { LayoutActions } from '.';
import { initialLayoutState } from './layout.state';

export const layoutReducers = createReducer(
  initialLayoutState,
  on(
    LayoutActions.setTotalScreenSize,
    (state, { totalScreenSize }) => ({ ...state, totalScreenSize: totalScreenSize })
  ),
  on(
    LayoutActions.setTotalWindowWidth,
    (state, { totalWindowWidth }) => ({ ...state, totalWindowWidth: totalWindowWidth })
  ),
  on(
    LayoutActions.setTotalWindowHeight,
    (state, { totalWindowHeight }) => ({ ...state, totalWindowHeight: totalWindowHeight })
  ),
  on(
    LayoutActions.setSidenavOpened,
    (state, { sidenavOpened }) => ({ ...state, sidenavOpened: sidenavOpened })
  ),
  on(
    LayoutActions.setPopoverWidth,
    (state, { popoverWidth }) => ({ ...state, popoverWidth: popoverWidth })
  ),
  on(
    LayoutActions.setPopoverDocked,
    (state, { popoverDocked }) => ({ ...state, popoverDocked: popoverDocked })
  ),
  on(
    LayoutActions.setToolbarZindex,
    (state, { toolbarZindex }) => ({ ...state, toolbarZindex: toolbarZindex })
  ),
  on(
    LayoutActions.setGlobalReference,
    (state, { globalReference }) => ({ ...state, globalReference: globalReference })
  ),
);